import { between } from 'polished'
import styled from 'styled-components'

export const Badge = styled.span`
  display: inline-flex;
  align-self: flex-start;
  font-size: ${between('16px', '24px')};
  font-family: ${({ theme }) => theme.font[1]};
  padding: 8px 6px 3px;
  line-height: 1;
  letter-spacing: -1px;

  ${({ color, appearance, theme }) => {
    if (appearance === 'solid') {
      return `
        color: ${theme.colors.light};
        background-color: ${theme.colors[color]};
      `
    }

    if (appearance === 'ghost') {
      return `
        color: ${theme.colors[color]};
        border: 2px solid ${theme.colors[color]};
      `
    }
  }}

  ${({ marginTop }) =>
    marginTop &&
    `
    margin-top: ${marginTop}px;
  `}

  ${({ marginBottom }) =>
    marginBottom &&
    `
    margin-bottom: ${marginBottom}px;
  `}

  ${({ marginLeft }) =>
    marginLeft &&
    `
    margin-left: ${marginLeft}px;
  `}

  ${({ marginRight }) =>
    marginRight &&
    `
    margin-right: ${marginRight}px;
  `}
`
